import { GAP_CLOSE, GAP_OPEN } from './alertSentence';

/** The live sentence at the top of the editor; gaps (still to fill in) are shown muted, not as errors. */
export default function AlertSentence(properties: { text: string }) {
    const parts = properties.text.split(new RegExp(`${GAP_OPEN}|${GAP_CLOSE}`));

    return (
        <p
            data-testid="alert-sentence"
            className="rounded-xl border bg-primary/5 px-4 py-3 text-sm leading-relaxed"
        >
            {parts.map((part, index) => (index % 2 === 1
                ? (
                    <span key={index} className="rounded border border-dashed px-1 text-muted-foreground">
                        {part}
                    </span>
                )
                : <span key={index}>{part}</span>))}
        </p>
    );
}
